import styled from "styled-components";

export const StyledResultsScreen = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100vh;
  padding: 100px 30px 100px 30px;
  background-color: ${({ theme }) => theme.colors.background};
  gap: 30px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 10% 5%;
  }

  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 24px;
    margin: 10px 0;
  }
  p {
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }
  .go-back {
    cursor: pointer;

    z-index: 99;

    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.backgroundOpacity};
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    img {
      height: 20px;
    }
  }
`;

export const SearchTriggerButton = styled.button`
  width: 100%;
  cursor: pointer;
  height: 52px;
  border-radius: 26px;
  border: 0.5px solid;
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  padding: 16px;
  z-index: 9;

  p {
    color: ${({ theme }) => theme.colors.text};
  }
`;
